/* eslint-disable require-jsdoc */

export function selectEncoutners(state) {
    return state.encounters.encounters;
}

export function selectWeekDay(state) {
    return state.encounters.weekDay;
}
